import { render, staticRenderFns } from "./customerPropertys.vue?vue&type=template&id=11b0f0a4&"
import script from "./customerPropertys.vue?vue&type=script&lang=js&"
export * from "./customerPropertys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b0f0a4')) {
      api.createRecord('11b0f0a4', component.options)
    } else {
      api.reload('11b0f0a4', component.options)
    }
    module.hot.accept("./customerPropertys.vue?vue&type=template&id=11b0f0a4&", function () {
      api.rerender('11b0f0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/checkout/customerPropertys.vue"
export default component.exports